import React, { useEffect } from 'react'
import { usePublicSettings } from '../hooks/queries/useSettings'

const ThemeSync: React.FC = () => {
  const { data } = usePublicSettings()

  useEffect(() => {
    if (!data?.theme) return
    const t = data.theme
    const root = document.documentElement
    root.style.setProperty('--color-primary', t.primary)
    root.style.setProperty('--color-primaryDark', t.primaryDark)
    root.style.setProperty('--color-primaryLight', t.primaryLight)
    root.style.setProperty('--color-accent', t.accent)
    root.style.setProperty('--color-accentDark', t.accentDark)
    root.style.setProperty('--color-accentLight', t.accentLight)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.theme_id])

  return null
}

export default ThemeSync
